export const SERVICES = [
  {
    id: "industrial",
    title: "Industrijske instalacije",
    short: "Kompletna elektroinstalacija proizvodnih pogona, fabrika i industrijskih objekata.",
    items: ["Razvodni ormari", "Visokonaponske instalacije", "Energetski monitoring", "Servis & održavanje"],
    icon: "Factory",
  },
  {
    id: "home",
    title: "Kućne instalacije",
    short: "Stambene elektroinstalacije i pametna kuća (smart home, KNX).",
    items: ["Pametne kuće (KNX)", "LED rasveta", "Audio/Video distribucija", "Punionice za EV"],
    icon: "House",
  },
  {
    id: "data",
    title: "Data & Mreže",
    short: "Strukturno kabliranje, optika i server room rešenja za poslovne korisnike.",
    items: ["CAT6A / CAT7 / Optika", "Server rackovi", "Wi-Fi & LAN dizajn", "Patch paneli & KVM"],
    icon: "Network",
  },
  {
    id: "security",
    title: "Sigurnosni sistemi",
    short: "Integrisani alarmni i protivpožarni sistemi sa 24/7 monitoringom.",
    items: ["Alarm & PIR senzori", "Protivpožarni sistem", "Detekcija provale", "Monitoring centar"],
    icon: "ShieldCheck",
  },
  {
    id: "access",
    title: "Kontrola pristupa",
    short: "RFID, biometrija i integracija sa HR sistemima za upravljanje pristupom.",
    items: ["RFID kartice", "Biometrijski čitači", "Turnstile sistemi", "HR integracija"],
    icon: "Fingerprint",
  },
  {
    id: "cctv",
    title: "Video nadzor",
    short: "IP kamere sa AI analitikom, NVR sistemi i 24/7 daljinski monitoring.",
    items: ["IP & PTZ kamere", "AI analitika", "NVR snimanje", "Daljinski pristup"],
    icon: "Video",
  },
];

export const COUNTRIES = [
  "Slovenija", "Hrvatska", "Srbija", "Bosna i Hercegovina", "Crna Gora", "Severna Makedonija",
  "Nemačka", "Austrija", "Švajcarska", "Italija", "Mađarska",
  "Holandija", "Belgija", "Luksemburg", "Francuska", "Irska", "Velika Britanija",
  "Španija", "Portugal", "Grčka",
  "Poljska", "Češka", "Slovačka", "Rumunija", "Bugarska",
  "Danska", "Švedska", "Norveška", "Finska", "Island",
  "Litvanija", "Letonija", "Estonija", "Malta", "Kipar", "Albanija", "Ukrajina",
];

export const STATS = [
  { value: "12+", label: "Godina iskustva" },
  { value: "100+", label: "Završenih projekata" },
  { value: "8", label: "EU zemalja" },
  { value: "24/7", label: "Tehnička podrška" },
];

export const COMPANY = {
  name: "DSVM Group",
  tagline: "Elektroinstalacije i sigurnosni sistemi širom EU",
  phone: "+49 157 5439 3549",
  email: "info@dsvmgroup.eu",
  address: "Stanetova cesta 21, 3000 Celje, Slovenija",
  short_address: "Celje, Slovenija",
  domain: "dsvmgroup.eu",
};

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_smart-building-tech-1/artifacts/5zw7az6f_IMG_6671.png";
